import optionsRepository from "../repositories/OptionsRepository";

class OptionsService {
    constructor() {}

    async getByType(type, status, withStatus) {
        return optionsRepository.getByType(type, status, withStatus);
    }

    async getOptionsByType(type, status, withStatus) {
        const options = await optionsRepository.getByType(type, status, withStatus);

        return options.data;
    }

    async createGroup(type, name) {
        return optionsRepository.createGroup(type, { name });
    }

    async updateGroup(id, values) {
        return optionsRepository.updateGroup(id, values);
    }

    async createGroupItem(id, name) {
        return optionsRepository.createGroupItem(id, { name });
    }

    async updateGroupItem(groupId, itemId, values) {
        return optionsRepository.updateGroupItem(groupId, itemId, values);
    }
}

export default new OptionsService();
